// latest: zhangmyh 2017-6-21 4:23 PM
/* global ko */
import './index.less'

ko.components.register('ag-grid', {
  viewModel: require('./grid/index').default,
  template: require('./grid/index.html')
})

ko.components.register('ag-grid-cell', {
  viewModel: require('./cell/index').default,
  template: require('./cell/index.html')
})



// WEBPACK FOOTER //
// ./src/components/ag-grid/index.js